export default __webpack_public_path__ + "static/media/site_settings_ja.0257f9c6.png";